import { useState } from 'react';
import InitFilters from '../../constants/InitFiltering';

const useCustomHook = () => {
  const [loading, setLoading] = useState(false);
  const [, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState(InitFilters());

  const [list, setList] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [isNewDialogOpen, setIsNewDialogOpen] = useState(false);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);

  const [itemIdToDelete, setItemIdToDelete] = useState(null); // id of item to delete
  const [currentId, setCurrentId] = useState(null);

  const [cardNumber, setCardNumber] = useState(null);
  const [cardName, setCardName] = useState(null);
  const [page, setPage] = useState(0);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);

  return {
    loading,
    setLoading,
    setFilterParams,
    size,
    setSize,
    isLoading,
    setIsLoading,
    filters,
    setFilters,
    list,
    setList,
    isSubmitting,
    setIsSubmitting,
    isNewDialogOpen,
    setIsNewDialogOpen,
    confirmDeleteModal,
    setConfirmDeleteModal,
    itemIdToDelete,
    setItemIdToDelete,
    currentId,
    setCurrentId,
    cardNumber,
    setCardNumber,
    cardName,
    setCardName,
    page,
    setPage,
    isLoadingDelete, setIsLoadingDelete
  };
};

export default useCustomHook;
